'use client';

import { Box, CartBadge, Flex, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import { FavoriteNavFilledIcon, FavoriteNavIcon, UserIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useEffect, useId } from 'react';
import { LoginMenu } from '../LoginMenu';
import { StoreMenu } from '../StoreMenu';
import { LocationPickButton } from './subcomponents/LanguagePicker/LocationPickButton';
import classes from './index.module.scss';

const omitFavoritesCTA = (favoritesCTA) => {
  const { isFilled = false } = favoritesCTA;
  const favoriteLinkProps = { ...favoritesCTA };
  delete favoriteLinkProps.isFilled;
  delete favoriteLinkProps.text;
  return { isFilled, omitFavoritesCTA: favoriteLinkProps };
};

export const UtilityLinks = ({
  isLoggedIn = false,
  locationPickerCTA,
  languagePicker,
  favoritesCTA,
  cartBadgeCTA,
  userName,
  userCTA,
  utilityLinksMobile, // unused in desktop
  userCTAMobile, // unused in desktop
  menuType,
  storeMenu,
  loginMenu,
  languageMenu,
  setMenuType,
  setIsOpenMobileMenu,
  className,
  ...rest
}) => {
  const storeMenuId = `store-menu-${useId()}`;
  const isStoreMenuOpen = menuType === 'store' && Boolean(storeMenu);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMenuType?.(null);
        if (setIsOpenMobileMenu) {
          setIsOpenMobileMenu(false);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [setMenuType, setIsOpenMobileMenu]);

  return (
    <Flex className={clsx(classes.utilityLinks, className)} {...rest}>
      {(locationPickerCTA || languagePicker) && (
        <Flex align="center" gap={25} paddingLeft={25}>
          {locationPickerCTA && (
            <LocationPickButton
              {...locationPickerCTA}
              aria-expanded={isStoreMenuOpen}
              aria-controls={isStoreMenuOpen ? storeMenuId : undefined}
            />
          )}
          {isStoreMenuOpen && (
            <Box className={classes.menuPositionWrapper}>
              <StoreMenu {...storeMenu} id={storeMenuId} setMenuType={setMenuType} setIsOpenMobileMenu={setIsOpenMobileMenu} />
            </Box>
          )}
          {/* {languagePicker && (
            <LanguagePicker
              {...languagePicker}
              languagePickerCTA={{
                'aria-controls': 'language-menu',
                'aria-activedescendant': menuType === 'language' ? 'language-menu' : undefined,
                'aria-expanded': menuType === 'language',
                ...languagePicker.languagePickerCTA,
              }}
            />
          )}
          {menuType && languageMenu && (
            <Box display={menuType !== 'language' ? 'none' : undefined} className={classes.menuPositionWrapper}>
              <LanguageMenu {...languageMenu} setMenuType={setMenuType} setIsOpenMobileMenu={setIsOpenMobileMenu} />
            </Box>
          )} */}
        </Flex>
      )}

      {(locationPickerCTA || languagePicker) && <div className={classes.divider} />}

      <Flex className={classes.utilityLink} gap={15} align="center">
        {userCTA && (
          <Box
            component="button"
            type="button"
            display="flex"
            textColor="var(--content-primary)"
            aria-label={isLoggedIn && userName ? `Hi, ${userName}` : 'Profile'}
            aria-expanded={menuType === 'user'}
            aria-controls={menuType && loginMenu ? "login-menu" : undefined}
            {...omitText(userCTA)}
          >
            {isLoggedIn && userName ? (
              <Typography size="label-medium-xs" 
              textColor="var(--content-primary)" 
              className={classes.userNameText}>
                Hi, {userName}
              </Typography>
            ) : (
              <UserIcon withBoundingBox={false} />
            )}
          </Box>
        )}
        {menuType && loginMenu && (
          <Box display={menuType !== 'user' ? 'none' : undefined} className={classes.menuPositionWrapper}>
            <LoginMenu {...loginMenu} setMenuType={setMenuType} setIsOpenMobileMenu={setIsOpenMobileMenu} />
          </Box>
        )}

        {favoritesCTA && (
          <Box
            component="a"
            display="flex"
            aria-label="see favorites"
            textColor="var(--content-primary)"
            {...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA}
          >
            {omitFavoritesCTA(favoritesCTA).isFilled ? (
              <FavoriteNavFilledIcon withBoundingBox={false} />
            ) : (
              <FavoriteNavIcon withBoundingBox={false} />
            )}
          </Box>
        )}

        {cartBadgeCTA && (
          <CartBadge
            display="flex"
            textColor="var(--content-primary)"
            component="a"
            aria-label="see cart"
            withBoundingBox={false}
            {...cartBadgeCTA}
          />
        )}
      </Flex>
    </Flex>
  );
};
